<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <template
        v-slot:activator="{ on }">
        <p>{{selected}}</p>
        <v-btn
          color="primary"
          dark
          v-on="on">Open Dialog</v-btn>
      </template>
      <v-card>
        <v-toolbar
          dark
          color="primary">
          <v-btn
            icon
            dark
            @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Conditions</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div
          style='column-count: 3;'>
          <div
            v-bind:key='i'
            v-for="(bucket, i) in condictions"
            style="text-align: center;">
            <h3>{{bucket.bucket}}</h3>
            <div
              class="w-50 p-3 align-center justify-center">
              <v-checkbox
              v-bind:key='i'
                v-for="(cond,i) in bucket.list"
                v-model="selected"
                :label="cond"
                :value="cond"></v-checkbox>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  import { mapFields } from "vuex-map-fields";
  export default {
    data () {
      return {
        dialog: false,
        selected: []
      }
    },
    mounted () {
    },
    props: {
    },
    methods: {
    },
    computed: {
      ...mapFields("patientQuestion", [
        "condictions"
      ])
    },
    components: {
    }
  }
</script>
